import React from 'react';
import { SiX, SiLinkedin, SiInstagram, SiWhatsapp, SiSnapchat, SiTiktok } from 'react-icons/si';
import { FiMail } from 'react-icons/fi';

interface SocialLink {
  href: string;
  icon: React.ReactNode;
  label: string;
  color: string;
}

const socialLinks: SocialLink[] = [
  {
    href: 'https://www.linkedin.com/company/enterpriseksa',
    icon: <SiLinkedin size={20} />,
    label: 'LinkedIn',
    color: '#0a66c2',
  },
  {
    href: 'https://x.com/enterprise_ksa',
    icon: <SiX size={18} />,
    label: 'X',
    color: '#000',
  },
  {
    href: 'https://www.instagram.com/ajarsaudi',
    icon: <SiInstagram size={20} />,
    label: 'Instagram',
    color: '#e1306c',
  },
  {
    href: 'mailto:customer.support@ajarglobal.com',
    icon: <FiMail size={20} />,
    label: 'Email',
    color: '#16a34a',
  },
  {
    href: 'https://api.whatsapp.com/send?phone=966920000028',
    icon: <SiWhatsapp size={20} />,
    label: 'WhatsApp',
    color: '#25d366',
  },
  {
    href: 'https://www.snapchat.com/@ajarsaudi',
    icon: <SiSnapchat size={20} />,
    label: 'Snapchat',
    color: '#fffc00',
  },
  {
    href: 'https://www.tiktok.com/@ajarsaudi',
    icon: <SiTiktok size={20} />,
    label: 'TikTok',
    color: '#010101',
  },
];

const Footer: React.FC = () => {
  return (
    <footer className="public-footer">
      <div className="footer-inner">

        {/* Logo */}
        <img
          src="/Ajar enterprise logo.png"
          alt="Ajar | Enterprise"
          className="footer-logo"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />

        {/* Social icons */}
        <div className="footer-socials">
          {socialLinks.map(({ href, icon, label, color }) => (
            <a
              key={label}
              href={href}
              target={href.startsWith('mailto') ? undefined : '_blank'}
              rel="noopener noreferrer"
              aria-label={label}
              className="footer-social-btn"
              style={{ '--social-color': color } as React.CSSProperties}
            >
              {icon}
            </a>
          ))}
        </div>

        {/* Contact & copyright */}
        <div className="footer-meta">
          <span>920000028</span>
        </div>
        <div className="footer-copy">
          © {new Date().getFullYear()} Al Jomaih Auto Rental. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
